<script lang="ts">
    import TemplateIcon from './TemplateIcon.svelte';
    import { Tooltip, tooltip } from '@svelte-plugins/tooltips';
    import JobPhotos from '../../components/Jobs/JobPhotos.svelte';
    import src from './svg/job_photo.svg';
    import { _ } from 'svelte-i18n';

    export let photos: string[] = [];
    export let scale: number = 0.7;

    let showWithTooltip: boolean = true;

    $: {
        photos = photos;
        showWithTooltip = false;
        setTimeout(() => showWithTooltip = true, 0);
    }
</script>

{#if showWithTooltip}
    <div use:tooltip={{content: {component: JobPhotos, props: {title: $_('Jobs photos')+':', photos: photos}}, theme: 'lastmile-tooltip', maxWidth: 400}} on:click={(evt) => { evt.stopPropagation(); }}>
        <TemplateIcon {src} alt="Photo added" {scale}/>
    </div>
{:else}
    <div on:click={(evt) => { evt.stopPropagation(); }}>
        <TemplateIcon {src} alt="Photo added" {scale}/>
    </div>
{/if}

<style>
    :global(.tooltip.lastmile-tooltip) {
        --tooltip-background-color: #f5f5f5;
    }
    :global(.tooltip.lastmile-tooltip-no-events) {
        --tooltip-background-color: #f5f5f5;
        pointer-events: none !important;
    }
</style>
